/**
 * Created by lk on 17/6/4.
 */
import axios from "../../utils/axios";
// 注册用户
export function userRegister(data) {
    return axios({
        url: "/index/register/register",
        method: "post",
        data: data
    });
}

// 获取用户资料
export function profileIndex(data) {
    return axios({
        url: "/admin/user/profile/get_profile",
        method: "post",
        data: data
    });
}

// 保存更新用户资料
export function profileSave(data) {
    return axios({
        url: "/admin/user/profile/save_profile",
        method: "post",
        data: data
    });
}

// 重置密码
export function profilePassword(data) {
    return axios({
        url: "/admin/auth/login/reset_password",
        method: "post",
        data: data
    });
}

// 管理员获取用户资料
export function admin(data) {
    return axios({
        url: "/admin/user/profile/admin",
        method: "POST",
        data: data
    });
}

//手机注册用户第一步
export function phone_register(data) {
    return axios({
        url: "/index/register/phone_register",
        method: "post",
        data: data
    });
}

//发送手机验证码
export function send_verify_code(data) {
    return axios({
        url: "/index/register/send_verify_code",
        method: "post",
        data: data
    });
}
